document.addEventListener('DOMContentLoaded', function () {
    function initializeHomeAboutCounters() {
        var counters = document.querySelectorAll('.home-about .stat-number__value');

        if (!counters.length) {
            return;
        }

        function animateCounter(counter) {
            if (counter.dataset.counted === 'true') {
                return;
            }

            counter.dataset.counted = 'true';

            var target = parseFloat(counter.getAttribute('data-count')) || 0;
            var duration = 1200;
            var startTime = null;

            function updateCounter(timestamp) {
                if (!startTime) {
                    startTime = timestamp;
                }

                var progress = Math.min((timestamp - startTime) / duration, 1);
                var value = Math.floor(progress * target);

                counter.textContent = value.toLocaleString();

                if (progress < 1) {
                    window.requestAnimationFrame(updateCounter);
                } else {
                    counter.textContent = target.toLocaleString();
                }
            }

            window.requestAnimationFrame(updateCounter);
        }

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        animateCounter(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.3 });

            counters.forEach(function (counter) {
                observer.observe(counter);
            });
        } else {
            counters.forEach(animateCounter);
        }
    }

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=home-about', initializeHomeAboutCounters);
        initializeHomeAboutCounters();
    } else {
        initializeHomeAboutCounters();
    }
});
